jQuery(document).ready(function ($) {
  $(".wp-block-sivananda-blocks-renting-list").each(function () {
    const
      // DOM
      $bodyHtml = $('body, html'),
      $rentingListBlock = $(this),
      $roomGallerySwipers = $rentingListBlock.find(".room-gallery-swiper"),
      $interestedInButtons = $rentingListBlock.find('.room-details button'),
      $form = $rentingListBlock.find('form'),
      $roomSelect = $form.find('select'),

      // helper funcs
      setUpRoomSelect = () => {
        const names = $rentingListBlock.find('.room-for-rent h2').map((index, element) => $(element).text()).toArray();

        names.forEach((name, index) => {
          $roomSelect.append(`<option value='${name}'>${name}</option>`);
        });

        $roomSelect.selectWoo({
          minimumResultsForSearch: -1,
          width: '100%'
        });
      },
      setUpSwiperGalleries = () => {
        $roomGallerySwipers.each(function (index, element) {
          $roomGallerySwiper = $(element);

          new Swiper(element, {
            loop: true,
            navigation: {
              prevEl: $roomGallerySwiper.find('.fa-chevron-left')[0],
              nextEl: $roomGallerySwiper.find('.fa-chevron-right')[0],
            }
          });
        });
      },
      setUpClickOnInterestedButton = () => {
        $interestedInButtons.on('click', function () {
          const roomName = $(this).closest('.room-for-rent').find('h2').text();

          $roomSelect.val(roomName).trigger('change');

          // scroll to form
          $bodyHtml.animate({
            scrollTop: $form.offset().top - 140
          }, 100, 'swing');
        });
      };

    setUpRoomSelect();
    setUpSwiperGalleries();
    setUpClickOnInterestedButton();
  });
});
